import PrepaidDesc from "component/Admin/Billing/PrepaidDesc";
import React, { Component } from "react";
import { AiOutlineClose } from "react-icons/ai";

import { NormalModal } from "../NormalModel";
import { SignPanel } from "../SignPanel";
import closeIcon from "assets/images/close.png";
import "./styles.scss";
import { NormalButton } from "../NormalButton";
import { Toast } from "service/toast";
import { transactionOrderChangeAct } from "redux/actions/transactionHistory";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TreatmentDesc from "component/Admin/Billing/TreatmentDesc";
import { commonCreateApi } from "redux/actions/common";

const NewLineText = (text) => {
  // debugger;

  let stringText = String(text).toString();
  stringText = stringText.replace(/<br\s*\/?>/g, " ");
  //yoonus changed code here to fix \n\r\n for new line
  const newText = stringText.split(`\n\r\n`).map((str) => (
    <p className="col-12" style={{ lineHeight: "1.0rem" }}>
      {str}
    </p>
  ));

  return newText;
};

//const termsText = `Terms and Condition: \n 1: Any free sessions, complimentary service, rewards programme purchased all are non-exchangeable or refundable. \n 2: All service packages are valid for twelve months from the date of purchase. \n 3: Deposits for A La carte service will be for forfeited for cancellation of less than 24hours before the treatment. \n 4: a) Deposit for package service will be forfeited if customer does not come to redeem the booked package after 12 months from the paid date. \n b) Deposits for package : If customer wants to make appointment for next treatment, their payment must paid more than the next treatment course. For any late cancellation or “no-show”, the company has the right to deduct 1 x treatment course from their treatment package (will be treated as the treatment is taken). \n 5: If customer arrived late for appointment,the company has the rights to reduce the session time accordingly or complete the treatment by the appointed time and charge full amount of the booked treatment.(Applicable for A La carte service and package) \n 6: Embrace Beauty Pte Ltd reserves the right to charge all utilized service at ala carte prices upon termination of the package. \n 7: Refund Policy: \n a) If customer do not wish to proceed with the services and made known to the company within the cooling off period of 5 working days (exclude Sat,Sun & Public Holidays),the company will refund 100% of what the customer had paid. The redeemed treatment of the package is strictly non-refundable . Mode of refund will be in cheque. \n b) Prepaid packages AFTER cooling-off period is non-refundable unless the customer provide a medical note. The balanced and un-utilized sessions will be pro-rated based on ala-carte price minus an administrative charges (10%) and refunded in the form of a cheque. The redeemed treatment of the package is strictly non-refundable. \n c) Product exchange is applicable within 5 working days from the date of sale and only if the product is intact and deemed in good condition with the discretion of the management final judgement.\n \n The Company reserves the right to amend the terms and conditions herein and/or the specific terms and conditions at anytime and the customer shall be bound by the amended terms and conditions. Notice of the amendments may be given by the Company to the customer in such a manner, as the Company deem fit and proper.`;
const termsText = ``;

export class PrintViewClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOrderModal: false,
      filterOrderChangeList: [],
      activeEmpId: "",
      activeEmpList: [],
      activeEmpListOrignal: [],

      activeEmpData: {},
    };
  }
  
  // handleCheckStatus
  handleChangeCheckStatus = (arrayData, name) => {
    if (arrayData) {
      const status = arrayData.some(
        (obj) =>
          obj.hasOwnProperty("name") &&
          obj.name === name &&
          obj.checked === true
      );
      return status;
    }
  };

  // handleCheckNameLabel
  handleCheckNameLabel = (arrayData, name) => {
   const matchedObj = arrayData.find(
    (obj) =>
      obj.hasOwnProperty("name") &&
      obj.name === name &&
      obj.checked === true
   );

   return matchedObj ? matchedObj.namelabel : "";
  };

  handleOrderChange = () => {
    this.setState({
      isOrderModal: true,
    });
  };

  handleCloseDialog = () => {
    this.setState({
      isOrderModal: false,
    });
  };

  componentDidMount() {
    const { stateData } = this.props;
    console.log(stateData, "stateData");
    if (stateData && stateData.bodyList && stateData.bodyList.length > 0) {
      const filteredData = stateData.bodyList.filter(
        (obj) => obj.id >= 7 && obj.id <= 15 && obj.checked
      );
      this.setState({
        filterOrderChangeList: filteredData,
        activeEmpListOrignal: filteredData,
      });
      this.props.transactionOrderChangeAct(filteredData);
    }
  }
  componentDidUpdate = (prevProps) => {
    const { stateData } = this.props;
    const { stateData: prevReadings } = prevProps;
    if (stateData !== prevReadings) {
      const filteredData = stateData.bodyList.filter(
        (obj) => obj.id >= 7 && obj.id <= 15 && obj.checked
      );

      this.setState({
        filterOrderChangeList: filteredData,
        activeEmpListOrignal: filteredData,
      });
      this.props.transactionOrderChangeAct(filteredData);
    }
  };

  // handleClicActive
  handleClicActive = (item) => {
    this.setState({ activeEmpData: item, activeEmpId: item.id });
  };

  // handleToSelectSingle
  handleToSelectSingle = () => {
    let activeEmp = this.state.activeEmpData;
    if (Object.keys(activeEmp).length !== 0) {
      let tempArray = [...this.state.activeEmpList];
      let existCheck = tempArray.find((obj) => obj.id === activeEmp.id);
      if (!existCheck) {
        tempArray.push(activeEmp);
        this.setState({
          activeEmpList: tempArray,
          // filterOrderChangeList: tempArray,
        });
      } else {
        Toast({
          type: "error",
          message: "Already Added",
        });
      }
    } else {
      Toast({
        type: "error",
        message: "Please select atleast one",
      });
    }
  };

  // handleToSave
  handleToSave = async () => {
    let { activeEmpList, activeEmpListOrignal } = this.state;
    if (activeEmpList.length === activeEmpListOrignal.length) {
      this.setState({
        filterOrderChangeList: this.state.activeEmpList,
        isOrderModal: false,
      });
      // this.props.handleCallBack(this.state.activeEmpList);
      // this.props.transactionOrderChangeAct(this.state.activeEmpList);
      const reorderIds = this.state.activeEmpList.map((h) => h.id);
      this.props
        .commonCreateApi(`invoicetemplateconfig/headerorderchange/`, {
          invtemp_ids: reorderIds,
        })
        .then(async (res) => {
          if (res.status === 201) {
            // console.log(res,"response");
            this.props.transactionOrderChangeAct(this.state.activeEmpList);
          }
        });
    } else {
      Toast({
        type: "error",
        message: "Please select all items",
      });
    }
  };

  // addAllSelect
  addAllSelect = () => {
    this.setState({
      activeEmpList: this.state.activeEmpListOrignal,
    });
  };

  // addAllSelect
  handleToClearAll = () => {
    this.setState({
      activeEmpId: "",
      activeEmpList: [],
      activeEmpData: {},
      filterOrderChangeList: this.state.activeEmpListOrignal,
    });
  };

  // addAllSelect
  handleRemoveItem = (id) => {
    let filterList = this.state.activeEmpList.filter((item) => item.id !== id);
    this.setState({
      activeEmpList: filterList,
    });
  };

  // handleReturnData
  handleReturn = (name, data) => {
    const {
      sa_custno,
      sa_custname,
      nric,
      cust_refer,
      cust_phone2,
      trans,
      sa_date,
      sa_time,
      issued,
    } = data;

    let returnValue = "";

    switch (name) {
      case "Code":
        returnValue = sa_custno;
        break;
      case "Name":
        returnValue = sa_custname;
        break;
      case "NRIC":
        returnValue = nric;
        break;
      case "Cust Refer":
        returnValue = cust_refer;
        break;
      case "Cust Phone":
        returnValue = cust_phone2;
        break;
      case "Trans":
        returnValue = trans;
        break;
      case "Date":
        returnValue = sa_date;
        break;
      case "Time":
        returnValue = sa_time;
        break;
      case "Issued":
        returnValue = issued;
        break;
      default:
        break;
    }

    return returnValue;
  };

  NewLineAddressText = (text) => {
    let stringText = text || "";
    // Split the text into lines using the "\n" character as a delimiter
    const lines = stringText.split(/\n|\\n/);

    // Create a new array of JSX paragraphs
    const paragraphs = lines.map((str, index) => (
      <p key={index} className="col-12" style={{ lineHeight: "1.0rem" }}>
        {str}
      </p>
    ));

    // Return the array of JSX paragraphs
    return paragraphs;
  };

  render() {
    let { stateData, responseData } = this.props;
    let {
      hdr_data = [],
      dtl_data = [],
      sub_data = {},
      taud_data = [],
      footer = {},
      company_hdr = {},
      taud_sub = {},
    } = responseData;
    let {
      activeEmpId,
      isOrderModal,
      filterOrderChangeList,
      activeEmpList,
      activeEmpListOrignal,
    } = this.state;
    let {
      showprepaid,
      prepaidlst,
      treatment = [],
      treatmentbal = false,
    } = footer;

    return (
      <div className="receipt card" id="printableArea">
        <div className="row py-3">
          <div className="col-md-3">
            {this.handleChangeCheckStatus(stateData?.headerList, "Logo") && (
              <div className="d-flex justify-content-center">
                <img
                  src={company_hdr ? company_hdr.logo : ""}
                  alt=""
                  width={"100px"}
                  height={"60px"}
                  className="printImgContainer"
                />
              </div>
            )}
          </div>
          <div className="col-md-6">
            {this.handleChangeCheckStatus(
              stateData?.headerList,
              "Company Name"
            ) && (
              <h6 className="text-center fs-18">
                {" "}
                {company_hdr?.name ? company_hdr?.name : ""}
                {"  "}
              </h6>
            )}
            {this.handleChangeCheckStatus(stateData?.headerList, "ROC") && (
              <h6 className="text-center fs-16">
                {` ${
                  company_hdr?.company_reg_no
                    ? "ROC : " + company_hdr?.company_reg_no
                    : ""
                }`}
              </h6>
            )}

            {this.handleChangeCheckStatus(
              stateData?.headerList,
              "Company Address"
            ) && (
              <p className="receipt-detail text-center">
                {company_hdr && company_hdr?.address
                  ? this.NewLineAddressText(company_hdr?.address)
                  : ""}
              </p>
            )}
          </div>

          <div className="col-md-3">
            {this.handleChangeCheckStatus(
              stateData?.headerList,
              "Tax Invoice"
            ) && (
              <p className="receipt-detail text-center">
                {hdr_data ? hdr_data?.invoice_header : ""}
              </p>
            )}
          </div>
        </div>

        <div className="bill-header" style={{ fontSize: "1rem" }}>
          <div className="row">
            <div className="col-12">
              <h6 className="orderChangeTitle" onClick={this.handleOrderChange}>
                Header order Change
              </h6>
            </div>
          </div>
          <div className="row ">
            {filterOrderChangeList.map((item, id) => {
              return (
                <div key={item.id} className="col-6">
                  <div>
                    {this.handleChangeCheckStatus(
                      stateData?.bodyList,
                      item.name
                    ) && (
                      <div className="row">
                        <div className="col-3 f-600 d-flex justify-content-start">
                          {item.name}
                        </div>
                        <div className="col-9 d-flex justify-content-start">
                          :{" "}
                          {hdr_data
                            ? this.handleReturn(item.name, hdr_data)
                            : ""}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          {/* <div className="row ">
            <div className="col-6">
              {this.handleChangeCheckStatus(stateData?.bodyList, "Code") && (
                <div className="row">
                  <div className="col-3 f-600">Code</div>
                  <div className="col-9">
                    : {hdr_data ? hdr_data.sa_custno : ""}
                  </div>
                </div>
              )}

              {this.handleChangeCheckStatus(stateData?.bodyList, "Name") && (
                <div className="row">
                  <div className="col-3  f-600">Name</div>
                  <div className="col-9">
                    : {hdr_data ? hdr_data.sa_custname : ""}
                  </div>
                </div>
              )}

              {this.handleChangeCheckStatus(stateData?.bodyList, "NRIC") && (
                <>
                  {hdr_data && hdr_data.is_nric ? (
                    <div className="row">
                      <div className="col-3  f-600">NRIC</div>
                      <div className="col-9">
                        : {hdr_data ? hdr_data.nric : ""}
                      </div>
                    </div>
                  ) : null}
                </>
              )}

              {this.handleChangeCheckStatus(
                stateData?.bodyList,
                "Cust Refer"
              ) && (
                <div className="row">
                  <div className="col-3  f-600">Cust Refer</div>
                  <div className="col-9">
                    : {hdr_data ? hdr_data.cust_refer : ""}
                  </div>
                </div>
              )}
              {this.handleChangeCheckStatus(
                stateData?.bodyList,
                "Cust Phone"
              ) && (
                <div className="row">
                  <div className="col-3  f-600">Cust Phone</div>
                  <div className="col-9">
                    : {hdr_data ? hdr_data.cust_phone2 : ""}
                  </div>
                </div>
              )}
            </div>
            <div className="col-6">
              {this.handleChangeCheckStatus(stateData?.bodyList, "Trans") && (
                <div className="row">
                  <div className="col-3  f-600">Trans</div>
                  <div className="col-9">
                    : {hdr_data ? hdr_data.trans : ""}
                  </div>
                </div>
              )}

              {this.handleChangeCheckStatus(stateData?.bodyList, "Date") && (
                <div className="row">
                  <div className="col-3  f-600">Date</div>
                  <div className="col-9">
                    : {hdr_data ? hdr_data.sa_date : ""}
                  </div>
                </div>
              )}

              {this.handleChangeCheckStatus(stateData?.bodyList, "Time") && (
                <div className="row">
                  <div className="col-3  f-600">Time</div>
                  <div className="col-9">
                    : {hdr_data ? hdr_data.sa_time : ""}
                  </div>
                </div>
              )}
              {this.handleChangeCheckStatus(stateData?.bodyList, "Issued") && (
                <div className="row">
                  <div className="col-3  f-600">Issued</div>
                  <div className="col-9">
                    : {hdr_data ? hdr_data.issued : ""}
                  </div>
                </div>
              )}
            </div>
          </div> */}
        </div>
        <div
          className="bill-detail mt-4 py-1"
          id="billDetailsHide"
          style={{ fontSize: ".915rem" }}
        >
          <div className="row m-0 table-header  f-600">
            {console.log(stateData, "stateData")}
            {this.handleChangeCheckStatus(stateData?.bodyList, "Table Sno") && (
              <div className="col text-left">No.</div>
            )}
            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Desc"
            ) && <div className="col-3 text-left">Description</div>}
            {this.handleChangeCheckStatus(stateData?.bodyList, "Table Qty") && (
              <div className="col text-left">Qty</div>
            )}
            {this.handleChangeCheckStatus(stateData?.bodyList, "Table U/P") && (
              <div className="col text-left">U/P</div>
            )}
            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Disc"
            ) && <div className="col text-left">Disc.</div>}
            {this.handleChangeCheckStatus(stateData?.bodyList, "Table N/P") && (
              <div className="col text-left">N/P</div>
            )}
            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Paid"
            ) && <div className="col text-left">Paid</div>}
            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Balance"
            ) && <div className="col d-none">Balance</div>}
            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Sold By"
            ) && <div className="col text-left">Sold By</div>}
            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Service By"
            ) && <div className="col text-left">Service By</div>}
          </div>
          <div id="firstloopdataHide">
            {dtl_data.length > 0
              ? dtl_data.map((item, index) => {
                  return (
                    <div className="row m-0 mt-2" key={index}>
                      {this.handleChangeCheckStatus(
                        stateData?.bodyList,
                        "Table Sno"
                      ) && <div className="col text-left">{index + 1}</div>}
                      {this.handleChangeCheckStatus(
                        stateData?.bodyList,
                        "Table Desc"
                      ) && (
                        <div className="col-3 text-left">
                          {item.dt_itemdesc}
                        </div>
                      )}
                      {this.handleChangeCheckStatus(
                        stateData?.bodyList,
                        "Table Qty"
                      ) && <div className="col text-left">{item.dt_qty}</div>}
                      {this.handleChangeCheckStatus(
                        stateData?.bodyList,
                        "Table U/P"
                      ) && <div className="col text-left">{item.dt_price}</div>}

                      {this.handleChangeCheckStatus(
                        stateData?.bodyList,
                        "Table Disc"
                      ) && <div className="col text-left">{item.discount}</div>}
                      {this.handleChangeCheckStatus(
                        stateData?.bodyList,
                        "Table N/P"
                      ) && (
                        <div className="col text-left">
                          {item.dt_transacamt}
                        </div>
                      )}

                      {this.handleChangeCheckStatus(
                        stateData?.bodyList,
                        "Table Paid"
                      ) && (
                        <div className="col text-left">{item.dt_deposit}</div>
                      )}
                      {this.handleChangeCheckStatus(
                        stateData?.bodyList,
                        "Table Balance"
                      ) && <div className="col d-none">{item.balance}</div>}
                      {this.handleChangeCheckStatus(
                        stateData?.bodyList,
                        "Table Sold By"
                      ) && (
                        <div className="col text-left">{item.sales_staff}</div>
                      )}
                      {this.handleChangeCheckStatus(
                        stateData?.bodyList,
                        "Table Service By"
                      ) && (
                        <div className="col text-left">{item.work_staff}</div>
                      )}
                    </div>
                  );
                })
              : ""}
          </div>

          <div className="row table-header sub-total m-0 fs-14 f-600 mt-5">
            {/* <div className="col-4 text-left">{sub_data.sub_total}</div> */}

            {this.handleChangeCheckStatus(stateData?.bodyList, "Table Sno") && (
              <div className="col text-left"></div>
            )}
            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Desc"
            ) && <div className="col-3 text-left"></div>}
            {this.handleChangeCheckStatus(stateData?.bodyList, "Table Qty") && (
              <div className="col text-left">{sub_data.tot_qty}</div>
            )}
            {this.handleChangeCheckStatus(stateData?.bodyList, "Table U/P") && (
              <div className="col text-left">{sub_data.tot_price}</div>
            )}
            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Disc"
            ) && <div className="col text-left">{sub_data.tot_disc}</div>}
            {this.handleChangeCheckStatus(stateData?.bodyList, "Table N/P") && (
              <div className="col text-left">{sub_data.tot_net}</div>
            )}

            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Paid"
            ) && <div className="col text-left">{sub_data.tot_paid}</div>}
            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Balance"
            ) && <div className="col d-none">{sub_data.tot_bal}</div>}
            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Sold By"
            ) && <div className="col text-left"></div>}
            {this.handleChangeCheckStatus(
              stateData?.bodyList,
              "Table Service By"
            ) && <div className="col text-left"></div>}
          </div>
        </div>
        <div className="payment-detail my-4  fw-600 mb-4">
          <div className="row m-0">
            <div className="col-7">
              <div className="row payment-header">
                <div className="col-4">No</div>
                <div className="col-4">Type</div>
                <div className="col-4 text-right">Amount</div>
              </div>
              {taud_data.length > 0
                ? taud_data.map((item, index) => {
                    return (
                      <div className="row payment-header" key={index}>
                        <div className="col-4">{item.pay_rem1}</div>
                        <div className="col-4">{item.pay_type_name}</div>
                        <div className="col-4 text-right">{item.pay_amt}</div>
                      </div>
                    );
                  })
                : ""}
              <div className="row payment-footer">
                <div className="col-4 fs-13">{taud_sub.gst_label}</div>
                <div className="col-4">Total</div>
                <div className="col-4 text-right">{taud_sub.total}</div>
              </div>
            </div>
            <div className="col-5 text-right">
              {this.handleChangeCheckStatus(
                stateData?.bodyList,
                "Sub Total"
              ) && (
                <div className="row">
                   <div className="col-6">
                    {this.handleCheckNameLabel(stateData?.bodyList, "Sub Total")}
                   </div>
                  <div className="col-6 text-right">{sub_data.sub_total}</div>
                </div>
              )}

              {this.handleChangeCheckStatus(stateData?.bodyList, "GST") && (
                <div className="row">
                  <div className="col-6">
                    {this.handleCheckNameLabel(stateData?.bodyList, "GST")}
                  </div>
                  <div className="col-6 text-right">{taud_sub.gst}</div>
                </div>
              )}
              {this.handleChangeCheckStatus(
                stateData?.bodyList,
                "Rounding"
              ) && (
                <div className="row">
                  <div className="col-6">Rounding :</div>
                  <div className="col-6 text-right">{taud_sub.rounding}</div>
                </div>
              )}

              {this.handleChangeCheckStatus(
                stateData?.bodyList,
                "Grand Total"
              ) && (
                <div className="row">
                  <div className="col-6">Grand Total :</div>
                  <div className="col-6 text-right">{taud_sub.grand_tot}</div>
                </div>
              )}

              {this.handleChangeCheckStatus(stateData?.bodyList, "Deposit") && (
                <div className="row">
                  <div className="col-6">Deposit :</div>
                  <div className="col-6 text-right">{sub_data.tot_paid}</div>
                </div>
              )}

              {this.handleChangeCheckStatus(
                stateData?.bodyList,
                "Outstanding"
              ) && (
                <div className="row">
                  <div className="col-6">Outstanding :</div>
                  <div className="col-6 text-right">{sub_data.outstanding}</div>
                </div>
              )}
            </div>
          </div>
          {/* used payment list */}
        </div>

        <PrepaidDesc footer={footer} />
        <TreatmentDesc footer={footer} />

        <div className=" mt-2" style={{ bottom: 0, textAlign: "start" }}>
          {this.handleChangeCheckStatus(stateData?.footerList, "Remarks") && (
            <>
              {footer.remark && <p className="py-1">Remark: {footer.remark}</p>}
            </>
          )}
          {this.handleChangeCheckStatus(
            stateData?.footerList,
            "Footer List"
          ) && (
            <>
              {footer.footer1 ? (
                <p className="fs-10">
                  {NewLineText(footer.footer1)}
                  {/*footer.footer1.replace(/<br\s*\/?>/g, " ")*/}
                </p>
              ) : (
                ""
              )}
              {footer.footer2 ? (
                <p className="fs-10">
                  {NewLineText(footer.footer2)}
                  {/*footer.footer2.replace(/<br\s*\/?>/g, " ")*/}
                </p>
              ) : (
                ""
              )}
              {footer.footer3 ? (
                <p className="fs-10">
                  {NewLineText(footer.footer3)}
                  {/*footer.footer3.replace(/<br\s*\/?>/g, " ")*/}
                </p>
              ) : (
                ""
              )}
              {footer.footer4 ? (
                <p className="fs-10">
                  {NewLineText(footer.footer4)}
                  {/*footer.footer4.replace(/<br\s*\/?>/g, " ")*/}
                </p>
              ) : (
                ""
              )}
              {footer.footer5 ? (
                <p className="fs-10">
                  {NewLineText(footer.footer5)}
                  {/*footer.footer5.replace(/<br\s*\/?>/g, " ")*/}
                </p>
              ) : (
                ""
              )}
              {footer.footer6 ? (
                <p className="fs-10">
                  {NewLineText(footer.footer6)}
                  {/*footer.footer6.replace(/<br\s*\/?>/g, " ")*/}
                </p>
              ) : (
                ""
              )}
            </>
          )}

          {this.handleChangeCheckStatus(
            stateData?.footerList,
            "Terms & Condition"
          ) && (
            <div className="row">
              <p className="fs-10">{NewLineText(termsText)}</p>
            </div>
          )}

          {this.handleChangeCheckStatus(stateData?.footerList, "Signature") && (
            <div className="d-flex justify-content-end ">
              <div className="col-3 text-center p-1">
                {company_hdr && company_hdr?.cust_sig ? (
                  <>
                    <img
                      className={`sigImage`}
                      alt=""
                      width={200}
                      height={150}
                      src={company_hdr?.cust_sig}
                    />
                    <p>Customer Signature</p>
                  </>
                ) : (
                  <SignPanel
                    handleSignSaveClick={(imgData) =>
                      this.props.handleSignSaveClick(imgData)
                    }
                  />
                )}
              </div>
            </div>
          )}
        </div>

        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "1020px" }}
          modal={isOrderModal}
          handleModal={this.handleCloseDialog}
        >
          <img
            onClick={this.handleCloseDialog}
            className="close curser-pointer"
            src={closeIcon}
            alt=""
          />

          <div className="mt-5">
            <h6 className="orderHeaderTitle">Order Change</h6>

            <div className="orderChangerWrap">
              <div className="row">
                <div className="col-md-5">
                  <h6 className="orderListContainer">Heading List</h6>
                  <div className="orderListHeader">
                    {activeEmpListOrignal.map((item, id) => {
                      return (
                        <h6
                          className={`orderListName ${
                            activeEmpId === item.id && "activeListOrder"
                          }`}
                          key={id}
                          onClick={() => this.handleClicActive(item)}
                        >
                          {item.name}
                        </h6>
                      );
                    })}
                  </div>
                </div>
                <div className="col-md-2  mt-3 mb-3">
                  <div className="row mt-4 w-100 m-0">
                    <NormalButton
                      buttonClass={"mx-2 w-100 p-0"}
                      mainbg={true}
                      className="confirm"
                      label={`>`}
                      outline={false}
                      onClick={() => {
                        this.handleToSelectSingle();
                      }}
                    />
                  </div>
                  <div className="row mt-4 w-100 m-0">
                    <NormalButton
                      buttonClass={"mx-2 w-100  p-0"}
                      mainbg={true}
                      className="confirm"
                      label={`>>`}
                      outline={false}
                      onClick={() => {
                        this.addAllSelect();
                      }}
                    />
                  </div>
                  <div className="row mt-4 w-100 m-0">
                    <NormalButton
                      buttonClass={"mx-2 w-100  p-0"}
                      mainbg={true}
                      className="confirm"
                      label={`Clear`}
                      outline={false}
                      onClick={() => {
                        this.setState({ activeEmpList: [] });
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-5">
                  <h6 className="orderListContainer">Order List</h6>
                  <div className="orderListHeader">
                    {activeEmpList.map((item, id) => {
                      return (
                        <div key={id} className="iconContainer">
                          <h6
                            className={`orderListName`}
                            onClick={() => this.handleClicActive(item)}
                          >
                            {item.name}
                          </h6>
                          <AiOutlineClose
                            size={20}
                            className="cursor-pointer"
                            onClick={() => this.handleRemoveItem(item.id)}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="row ">
                <div className="col-md-12  mt-3 mb-3">
                  <div className="row justify-content-end px-4">
                    <div className="col-md-2 mt-4  m-0">
                      <NormalButton
                        buttonClass={"mx-2 w-100 p-0"}
                        mainbg={true}
                        className="confirm"
                        label={`Save`}
                        outline={false}
                        onClick={() => {
                          this.handleToSave();
                        }}
                      />
                    </div>
                    <div className="col-md-2 mt-4  m-0">
                      <NormalButton
                        buttonClass={"mx-2 w-100  p-0"}
                        mainbg={true}
                        className="confirm"
                        label={`Cancel`}
                        outline={false}
                        onClick={() => {
                          this.setState({
                            isOrderModal: false,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      transactionOrderChangeAct,
      commonCreateApi,
    },
    dispatch
  );
};

export const PrintView = connect(null, mapDispatchToProps)(PrintViewClass);